import React, { ForwardedRef, useContext } from 'react';
import { OriginIconProps } from '../type';
import { Context } from '../context';

function IconRightComponent(props: OriginIconProps, ref: ForwardedRef<SVGSVGElement>) {
    const { prefix: prefixFromContext } = useContext(Context);
    const { className = '', prefix: prefixFromProps, width = '1em', height = '1em', useCurrentColor = true, spin, ...rest } = props;

    const prefix = prefixFromProps || prefixFromContext || 'alliance';
    const loadingKls = spin ? ` ${prefix}-icon-loading` : '';
    return <svg className={`${prefix}-icon ${prefix}-icon-right${loadingKls} ${className}`} width={width} height={height} viewBox="0 0 16 16" fill={useCurrentColor ? 'currentColor' : '#000'} xmlns="http://www.w3.org/2000/svg" {...rest} ref={ref}><path fillRule="evenodd" clipRule="evenodd" d="M5.43883 3.77937C5.30865 3.90954 5.30865 4.1206 5.43883 4.25077L9.18811 8.00003L5.43883 11.7493C5.30865 11.8795 5.30865 12.0905 5.43883 12.2207L5.91024 12.6921C6.04041 12.8223 6.25146 12.8223 6.38164 12.6921L10.6023 8.47144C10.8627 8.21109 10.8627 7.78898 10.6023 7.52863L6.38164 3.30797C6.25146 3.17779 6.04041 3.17779 5.91024 3.30797L5.43883 3.77937Z" fillOpacity="1"/></svg>;
}

const IconRight = React.forwardRef(IconRightComponent);
export default IconRight;
